// extracted by mini-css-extract-plugin
export default {"HeaderBlock_padded":"HeaderBlock_HeaderBlock_padded__hpJh9","HeaderBlock__header":"HeaderBlock_HeaderBlock__header__sUPx2"};